import * as React from 'react';

export type CssPolicy = "static-only" | "runtime-only" | "static-first";

export type EngineConfig = Readonly<{
  cssPolicy: CssPolicy;
}>;

const EngineConfigContext = React.createContext<EngineConfig | null>(null);

export function useEngineConfig(): EngineConfig | null {
  return React.useContext(EngineConfigContext);
}

export const EngineConfigProvider: React.FC<
  React.PropsWithChildren<{config: EngineConfig}>
> = ({config, children}) => {
  const parentConfig = useEngineConfig();
  const mergedConfig = React.useMemo(
    () => ({
      ...(parentConfig ?? {}),
      ...config,
    }),
    [parentConfig, config],
  );

  return (
    <EngineConfigContext.Provider value={mergedConfig}>
      {children}
    </EngineConfigContext.Provider>
  );
};
